export type NavbarTheme = {
  background: string;
  textColor: string;
  headerBorderColor: string;
  navTextTransform: 'none' | 'uppercase';
  navLetterSpacing: string;
  navFontSize: string;
  navFontWeight: number;
  navIconColor: string;
  navIconOpacity: number;
  hoverBackground: string;
  activeBackground: string;
  activeTextColor: string;
  activeIconColor: string;
  activeIconOpacity: number;
  dashboardNameTransform: 'capitalize' | 'uppercase';
  mobileIconColor: string;
  primaryButtonBackground: string;
  primaryButtonColor: string;
  primaryButtonHoverBackground: string;
  secondaryButtonBackground: string;
  secondaryButtonColor: string;
  secondaryButtonBorderColor: string;
  orgLogoWidth?: string;
  orgLogoHeight?: string;
  brandImageWidth?: string;
  brandImageHeight?: string;
  brandImageSrc?: string;
  brandImageAlt?: string;
  brandImageTitle?: string;
};

const defaultTheme: NavbarTheme = {
  background: '#464854',
  textColor: '#ffffff',
  headerBorderColor: '#6b6c7d',
  navTextTransform: 'none',
  navLetterSpacing: 'normal',
  navFontSize: '14px',
  navFontWeight: 600,
  navIconColor: '#b5b6c5',
  navIconOpacity: 1,
  hoverBackground: 'rgba(0, 0, 0, 0.25)',
  activeBackground: '#ffffff',
  activeTextColor: '#3a3b4a',
  activeIconColor: '#e5380c',
  activeIconOpacity: 1,
  dashboardNameTransform: 'capitalize',
  mobileIconColor: '#ffffff',
  primaryButtonBackground: '#ffffff',
  primaryButtonColor: '#464854',
  primaryButtonHoverBackground: '#bdbbb9',
  secondaryButtonBackground: 'transparent',
  secondaryButtonColor: '#ffffff',
  secondaryButtonBorderColor: 'transparent',
  brandImageSrc: 'img/mgpro_logo_sm.svg',
  brandImageAlt: 'Ministry Grid',
};

const themes: Record<string, Partial<NavbarTheme>> = {
  GRID: {},
  CENTRIKID: {
    background: '#2ebec0',
    headerBorderColor: 'rgb(250, 180, 121)',
    navTextTransform: 'uppercase',
    navLetterSpacing: '0.05em',
    navFontSize: '12px',
    navFontWeight: 600,
    navIconColor: 'currentColor',
    navIconOpacity: 0.75,
    hoverBackground: '#29abac',
    activeBackground: '#ffffff',
    activeTextColor: '#060a3b',
    activeIconColor: '#2ebec0',
    dashboardNameTransform: 'uppercase',
    brandImageWidth: 'auto',
    brandImageHeight: '40px',
    brandImageSrc: 'img/centrikid_logo_white.svg',
    brandImageTitle: 'Centrikid Camps',
    brandImageAlt: '',
  },
  CONNEXUS: {
    background: '#808186',
    headerBorderColor: '#da744d',
    navTextTransform: 'uppercase',
    navLetterSpacing: '0.05em',
    navFontSize: '12px',
    navFontWeight: 600,
    navIconColor: 'currentColor',
    navIconOpacity: 0.75,
    hoverBackground: 'rgba(0, 0, 0, 0.15)',
    activeBackground: '#ffffff',
    activeTextColor: '#4c5760',
    activeIconColor: '#808186',
    dashboardNameTransform: 'uppercase',
    brandImageSrc: 'img/connexus_logo_white.svg',
    brandImageAlt: 'Connexus Church Training',
    brandImageWidth: 'auto',
    brandImageHeight: '40px',
  },
  FUGE: {
    background: 'rgb(238, 45, 56)',
    headerBorderColor: 'rgba(255, 255, 255, 0.15)',
    navTextTransform: 'uppercase',
    navLetterSpacing: '0.05em',
    navFontSize: '12px',
    navFontWeight: 600,
    navIconColor: 'currentColor',
    navIconOpacity: 0.75,
    hoverBackground: '#d61f2a',
    activeBackground: '#000000',
    activeTextColor: '#ffffff',
    activeIconColor: '#08bdbd',
    activeIconOpacity: 1,
    dashboardNameTransform: 'uppercase',
    brandImageWidth: 'auto',
    brandImageHeight: '23px',
    brandImageSrc: 'img/fuge_logo.png',
    brandImageTitle: 'FUGE Training Online',
    brandImageAlt: '',
  },
  STUDENTLIFE: {
    background: '#77cbc6',
    headerBorderColor: '#444f5e',
    navTextTransform: 'uppercase',
    navLetterSpacing: '0.05em',
    navFontSize: '12px',
    navFontWeight: 600,
    navIconColor: 'currentColor',
    navIconOpacity: 0.75,
    hoverBackground: 'rgba(0, 0, 0, 0.3)',
    activeBackground: '#e0e6e6',
    activeTextColor: '#162b48',
    activeIconColor: '#77cbc6',
    dashboardNameTransform: 'uppercase',
    brandImageSrc: 'img/studentlife_logo.png',
    brandImageTitle: 'Student Life Camp Training Online',
    brandImageAlt: '',
  },
  SBC: {
    background: '#004680',
    headerBorderColor: '#3883bc',
    navTextTransform: 'uppercase',
    navLetterSpacing: '0.05em',
    navFontSize: '12px',
    navFontWeight: 600,
    navIconColor: 'currentColor',
    navIconOpacity: 0.75,
    hoverBackground: 'rgba(0, 0, 0, 0.3)',
    activeBackground: '#ffffff',
    activeTextColor: '#004680',
    activeIconColor: '#004680',
    dashboardNameTransform: 'uppercase',
    brandImageSrc: 'img/sbc_logo_sm.png',
    brandImageTitle: 'SBC Training & Orientation Portal',
    brandImageAlt: '',
  },
};

export function getNavbarTheme(origin: string): NavbarTheme {
  return {
    ...defaultTheme,
    ...(themes[origin] || {}),
  };
}
